
import * as defaultImport from "@splunk/react-ui/Tooltip";
export * from "@splunk/react-ui/Tooltip";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
